import { render, staticRenderFns } from "./invoiceInfo.vue?vue&type=template&id=422994c8&scoped=true"
import script from "./invoiceInfo.vue?vue&type=script&lang=js"
export * from "./invoiceInfo.vue?vue&type=script&lang=js"
import style0 from "./invoiceInfo.vue?vue&type=style&index=0&id=422994c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422994c8",
  null
  
)

export default component.exports